var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "custom-info-icon",
    d: "M9.0075 1.5C13.1487 1.50414 16.5028 4.86384 16.5 9.005C16.4972 13.1462 13.1387 16.5014 8.9975 16.5C4.85634 16.4986 1.5 13.1412 1.5 9C1.50248 4.85597 4.86346 1.49834 9.0075 1.5ZM15 8.871C14.9645 5.57007 12.2692 2.91784 8.96809 2.9355C5.66702 2.95333 3.00035 5.63438 3.00035 8.93551C3.00035 12.2366 5.66702 14.9177 8.96809 14.9355C12.2692 14.9532 14.9645 12.3009 15 9V8.871ZM8.25 5.25L9.75 5.25L9.75 6.75L8.25 6.75V5.25ZM8.25 8.25L9.75 8.25V12.75H8.25L8.25 8.25Z",
    fill: "#2262ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomInfoIcon);
export default __webpack_public_path__ + "static/media/custom_info_icon.2752106daa2b208d5e9968afa650d7f5.svg";
export { ForwardRef as ReactComponent };